import {accountHasFeature} from 'helpers/user'
import {features} from 'helpers/constants'
import {ScalingType} from 'helpers/constants'
import {getBasePack, getDefaultPack, getPartPacks} from 'helpers/packs'
import {get, isNil} from 'lodash'
import {canUsePack, getMinPackQuantity} from "helpers/parts"

export const isAssembliesEnabled = (user) => {
  return accountHasFeature(user, features.PRICE_LISTS_LICENCE) &&
      accountHasFeature(user, features.ASSEMBLIES)
}

export const createPartContentFromPart = (part, selectedPart, content) => {
  const partPacks = getPartPacks(selectedPart, true)
  const defaultPack = getDefaultPack(partPacks)
  const partPack = isNil(defaultPack)
      ? getBasePack(partPacks)
      : defaultPack

  const partContents = getPartContents(part)
  return {
    id: -1,
    parentPartId: part.id,
    partId: selectedPart.id,
    quantity: content ? content.quantity : canUsePack(partPack) ? getMinPackQuantity(partPack) : 1,
    sizeX: selectedPart.sizeX,
    sizeY: selectedPart.sizeY,
    sizeZ: selectedPart.sizeZ,
    order: partContents.length,
    scalingType: ScalingType.VARIABLE.id,
    partPackId: partPack.id,
    guid: null,
  }
}

export const getPartContents = (part) => {
  const partContents = get(part, 'contents', [])
  return isNil(partContents)
      ? []
      : partContents
}

export const getPartContentUnitPrice = (partContent) => {
  return get(partContent, 'price.unitPrice', null)
}

export const getPartContentUnitCost = (partContent) => {
  return get(partContent, 'price.unitCost', null)
}

export const getPartContentTotalPrice = (partContent) => {
  return get(partContent, 'price.totalPrice', null)
}

export const getPartContentTotalCost = (partContent) => {
  return get(partContent, 'price.totalCost', null)
}

export const updatePartContentsFor = (partContent, part) => {
  const partContents = getPartContents(part)
  const partContentIndex = partContents.findIndex(p => p.id === partContent.id)

  if (partContentIndex === -1) {
    partContents.push(partContent)
  } else {
    partContents[partContentIndex] = partContent
  }

  const updatedPart = {...part}
  updatedPart['contents'] = partContents

  return updatedPart
}

export const updatePartContentsWith = (updatedPartContent, partContentId, part) => {
  const updatedPart = {...part}
  const partContents = getPartContents(part)

  updatedPart.contents = partContents
      .slice()
      .map(partContent => {
        return partContent.id === updatedPartContent.id
            ? updatedPartContent
            : partContent
      })

  return updatedPart
}

export const deletePartContent = (partContent, part) => {
  const partContents = getPartContents(part)

  const updatedPart = {...part}
  updatedPart['contents'] = partContents.filter(p => p.id !== partContent.id)
  updatedPart['deletedContents'] = [partContent]

  return updatedPart
}
